import React from 'react';
import { ApiDisplay } from '../../../ApiDisplay';
import { Rectangle } from '../../../PageElements/Rectangle/Rectangle';
import { Text, WEIGHTS } from '../../../PageElements/Text';
import style from './metaDataRectangle.scss';

interface MetaDataRectangleProps {
  artifactId?: string;
  serviceName?: string;
  topic?: string;
}

export const MetaDataRectangle = ({
  artifactId,
  serviceName,
  topic,
}: MetaDataRectangleProps) => {
  const shouldRender = artifactId || serviceName || topic;

  if (!shouldRender) {
    return null;
  }

  return (
    <ApiDisplay.RpcRest matchInitialType>
      <Rectangle className={style.metaDataRect} dataHook="meta-data-rectangle">
        {artifactId && (
          <Text
            weight={WEIGHTS.bold}
            dataHook="meta-data-rectangle-artifact-id"
          >
            Artifact: <Text tagName="span">{artifactId}</Text>
          </Text>
        )}
        {serviceName && (
          <Text
            weight={WEIGHTS.bold}
            dataHook="meta-data-rectangle-service-name"
          >
            Service: <Text tagName="span">{serviceName}</Text>
          </Text>
        )}
        {topic && (
          <Text weight={WEIGHTS.bold} dataHook="meta-data-rectangle-topic">
            Event Topic: <Text tagName="span">{topic}</Text>
          </Text>
        )}
      </Rectangle>
    </ApiDisplay.RpcRest>
  );
};
